module.exports = __webpack_public_path__ + "static/media/leftArrow.e0ab00dc.svg";